import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  emptyFormName: {
    id: 'proforma-form-system.add-form.ui.empty-form-name',
    defaultMessage: 'Untitled Form',
    description: 'A placeholder for a form with an empty name.'
  },
  addFormButton: {
    id: 'proforma-form-system.add-form.ui.add-form-button',
    defaultMessage: 'Add',
    description: 'Add form button text'
  },
  cancelButton: {
    id: 'proforma-form-system.add-form.ui.cancel-button',
    defaultMessage: 'Cancel',
    description: 'Form cancel button text'
  },
  addFormSelectInputPlaceholder: {
    id: 'proforma-form-system.add-form.ui.add-form-select-input-placeholder',
    defaultMessage: 'Select a form',
    description: 'Placeholder text for add form dropdown'
  },
  addFormSelectGroupRecommended: {
    id: 'proforma-form-system.add-form.ui.add-form-select-group-recommended',
    defaultMessage: 'Recommended',
    description: 'Option group text for recommended forms'
  },
  addFormSelectGroupOther: {
    id: 'proforma-form-system.add-form.ui.add-form-select-group-other',
    defaultMessage: 'Other Forms',
    description: 'Option group text for avaiable or other forms'
  }
});